import React from 'react';
import { observer } from 'mobx-react';
import { BaasicConfirmModal, Loader, BaasicModal } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import { ButtonGroup, Button } from '@progress/kendo-react-buttons';
import { AddressValidationTemplate } from 'themes/modules/order/pages';
import BasicRadio from 'themes/components/forms/BasicRadio';
import _ from 'lodash';

const WizardContainerTemplate = ({
	t,
	config,
	wizardStore: {
		loading,
		wizardStep,
		stepForm,
		getStepName,
		navigateToStep,
		leavePageConfirm,
		onNextStep,
		rootStore: { marketplaceOrderEditViewStore },
	},
	itemName,
	applyToAllActiveOrdersConfirmModal,
	disabled,
	goBack,
}) => {
	if (loading || !wizardStep) return <Loader />;
	let stepFormName = getStepName(_.findIndex(config, { component: wizardStep.component }) + 1);

	return (
		<React.Fragment>
			<div className="layout__main__subheader">
				<div className="flex--primary">
					<button className="btn layout__main__subheader__back" onClick={goBack}>
						<i className="fa fa-long-arrow-alt-left spc--right--tny"></i>
						{t('BACK')}
					</button>
					<h3 className="layout__main__subheader__title">{t(itemName)}</h3>
				</div>
			</div>
			<div className="step__container">
				{config.map(step => {
					return (
						<div className="" key={`${step.order}-${step.title}`}>
							<a
								className={
									'step__item ' +
									(step.component === wizardStep.component
										? 'is-active'
										: step.order === config.length
										? 'is-done'
										: '')
								}
								type="button"
								value={step}
								key={step.title.toString()}
								onClick={() => {
									navigateToStep(step);
								}}
							>
								<div
									className={
										`step__number ` +
										(!step.isValid
											? 'step__number--warning '
											: step.component === wizardStep.component
											? 'is-active'
											: '')
									}
								>
									{step.order}
								</div>
								<div className={'step__title ' + (step.component === wizardStep.component ? 'is-active' : '')}>
									{t(step.title)}
								</div>
							</a>
						</div>
					);
				})}
			</div>
			<form className="form" onSubmit={stepForm.onSubmit}>
				<div className="step__wrapper">
					<div className="step__form">
						<wizardStep.component form={stepForm.$(stepFormName)} />
					</div>
				</div>
				<div className="step__buttons__wrapper">
					<div className="group step__buttons">
						<React.Fragment>
							{_.first(config).component === wizardStep.component ? (
								<div className="">
									<div className="pull">
										<button
											className={'btn btn--med btn--tertiary'}
											type="button"
											disabled
											onClick={() => {
												onNextStep(wizardStep, -1);
											}}
										>
											<i className="fa fa-long-arrow-alt-left spc--right--tny"></i> {t('PREVIOUS')}
										</button>
									</div>
								</div>
							) : (
								<div className="">
									<div className="pull">
										<button
											className={'btn btn--med btn--tertiary'}
											type="button"
											onClick={() => {
												onNextStep(wizardStep, -1);
											}}
										>
											<i className="fa fa-long-arrow-alt-left spc--right--tny"></i> {t('PREVIOUS')}
										</button>
									</div>
								</div>
							)}
						</React.Fragment>
						<div className="group">
							<div className="type--right push">
								<button className={'btn btn--med btn--success'} type="submit" disabled={loading}>
									{loading ? (
										<div className="spinnercont spc--right--sml">
											<div className="spinner"></div>
										</div>
									) : null}
									{t('SAVE')}
								</button>
								{_.last(config).component === wizardStep.component ? (
									<button
										className={'btn btn--med btn--tertiary spc--left--tny'}
										type="button"
										disabled
										onClick={() => {
											onNextStep(wizardStep, 1);
										}}
									>
										{t('NEXT')}
										<i className="fa fa-long-arrow-alt-right spc--left--tny"></i>
									</button>
								) : (
									<button
										className={'btn btn--med btn--tertiary spc--left--tny'}
										type="button"
										onClick={() => {
											onNextStep(wizardStep, 1);
										}}
									>
										{t('NEXT')}
										<i className="fa fa-long-arrow-alt-right spc--left--tny"></i>
									</button>
								)}
							</div>
						</div>
					</div>
				</div>
				{/* If is marketplace order created/edit page, allow for address verification. */}
				{marketplaceOrderEditViewStore && (
					<BaasicModal modalParams={marketplaceOrderEditViewStore.addressValidationModal}>
						<AddressValidationTemplate
							viewStore={marketplaceOrderEditViewStore}
							form={marketplaceOrderEditViewStore.form.$('shippingStep')}
							t={t}
						/>
					</BaasicModal>
				)}
			</form>
			<BaasicConfirmModal modalParams={leavePageConfirm} />
			{applyToAllActiveOrdersConfirmModal != null && (
				<BaasicConfirmModal modalParams={applyToAllActiveOrdersConfirmModal} disabled={disabled} />
			)}
		</React.Fragment>
	);
};

export default defaultTemplate(WizardContainerTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/product/wizard/pages/WizardContainerTemplate.jsx